import styled from '@emotion/styled';

export const Wrapper = styled.div`
  padding: 90px 0px;
  background: ${(props) => props.theme.color.blue.lightBlue};
`;

export const SignupButtonWrapper = styled.div`
  margin-top: 25px;
`;
